import { Component, HostBinding, OnChanges } from '@angular/core';
import { CmsStyles } from 'cms/common/ui/cms-common-styles/cms-common-styles.component';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { RenderByDeviceService } from 'render/services/base-render-by-device/render-by-device.service';


import { PieceTextSettings } from './models/piece-text.models';
import { getWysiwygAligmentClasses } from './piece-text-utils';


@Component({
  selector: 'piece-text-render',
  templateUrl: './piece-text-render.component.html',
  styleUrls: ['./piece-text-render.component.scss']
})
export class PieceTextRenderComponent
  extends BaseRenderComponent<PieceTextSettings>
  implements OnChanges {

  @HostBinding('class') public aligmentClasses: string | undefined;

  public showFullText: boolean = false;

  @HostBinding('class.text-dropdown')
  public get isTextDropdownEnabled(): boolean {
    return !!this.settings.general?.textDropdownMode?.status;
  }

  @HostBinding('class.text-dropdown-expanded')
  public get isTextDropdownExpanded(): boolean {
    return this.isTextDropdownEnabled && this.showFullText;
  }

  @HostBinding('style')
  public get dropdownLines(): string | undefined {
    if (this.isTextDropdownEnabled && !this.showFullText) {
      return `--line-clamp-desktop: ${this.settings.general.textDropdownMode!.linesSummaryDesktop};
        --line-clamp-mobile: ${this.settings.general.textDropdownMode!.linesSummaryMobile};
        --color-linear-gradient: ${this.settings.styles.bgColor ? this.settings.styles.bgColor : '#fff'};`;
    }
    return undefined;
  }

  @HostBinding('class.marquee')
  public get isMarqueeTextAnimationEnabled(): boolean {
    return !!this.settings.general?.marquee?.marqueeStatus;
  }

  @HostBinding('style.--marquee-duration')
  public get marqueeTextDuration(): string | undefined {
    if (this.isMarqueeTextAnimationEnabled) {
      if (this.renderByDeviceService.isMobile) {
        return this.marqueeDurationMobileValue ? `${this.marqueeDurationMobileValue}s` : '5s';
      }
      return this.marqueeDurationDesktopValue ? `${this.marqueeDurationDesktopValue}s` : '20s';
    }
    return undefined;
  }

  @HostBinding('class.text-blink')
  public get isBlinkActive(): boolean {
    return !!this.settings.general?.blink;
  }

  public get htmlContent(): string | undefined {
    if (this.settings.general?.enableByDevice && this.renderByDeviceService.isMobile) {
      return this.settings.general?.textMobile;
    }
    return this.settings.general?.text;
  }

  public get styles(): CmsStyles {
    return {
      ...this.settings.styles ?? {},
      shadow: this.settings.general.shadow
    };
  }

  public get marqueeDurationDesktopValue(): number | undefined {
    return this.settings.general?.marquee?.marqueeDurationDesktop;
  }

  public get marqueeDurationMobileValue(): number | undefined {
    return this.settings.general?.marquee?.marqueeDurationMobile;
  }

  public get toggleExpandedText(): string {
    if (this.showFullText) {
      return this.settings.general.textDropdownMode?.seeLessText ?? '';
    }

    return this.settings.general.textDropdownMode?.seeMoreText ?? '';
  }

  constructor(private readonly renderByDeviceService: RenderByDeviceService) {
    super();
  }

  public ngOnChanges() {
    if (this.piece) {
      this.aligmentClasses = getWysiwygAligmentClasses(this.piece);
    }
  }

  public showPlaceholder() {
    return this.type === 'workspace' && !this.settings.general?.text;
  }

}
